import { appPermissions } from '@/libs/auth/permissions/appPermissions';
import { beforeEnterCheckPermission } from './utils/routePermissions';

export default [
  {
    name: 'roles-management',
    path: '/rolesManagement',
    component: () => import('@/views/roles/RolesManagement.vue'),
    meta: {
      title: 'ادارة الادوار',
    },
    beforeEnter(to, from, next) {
      const { has, redirectTo } = beforeEnterCheckPermission(
        appPermissions.roles,
      );
      if (has) return next();
      else return next(redirectTo);
    },
  },
];
